import React, { useEffect, useState } from "react";
import "./hostScreen.css";
import LocationIconSvg from "../../assets/ReactSvg/LocationIconSvg";
import MessageIconSvg from "../../assets/ReactSvg/MessageIconSvg";
import CalendarIconSvg from "../../assets/ReactSvg/CalendarIconSvg";
import ClockRoundIconSvg from "../../assets/ReactSvg/ClockRoundIconSvg";
import ClockIconSvg from "../../assets/ReactSvg/ClockIconSvg";
import RightIconSvg from "../../assets/ReactSvg/RightIconSvg";
import { useSelector } from "react-redux";
import { S3_MENU_THUMBNAIL_FOLDER } from "../../store/constants";
import { getStatusLabel } from "../../utils/timeHelper";
import HostImageGrid from "./HostImageGrid";
import { Spin } from "antd";

const HostDetailsComponent = ({ hostDetails, onChefClick, onViewAllClick }) => {
  const chefList = useSelector((state) => state.chef.chefList);
  const deliveryDetails = useSelector(({ auth }) => auth.deliveryDetails);
  const isServiceable = useSelector((state) => state.auth.isServiceable);

  const [loadedCount, setLoadedCount] = useState(0);
  const [totalMedia, setTotalMedia] = useState(0);
  const [showFullAboutText, setShowFullAboutText] = useState(false);
  
  const getAllPhotos = (data) => data.flatMap((item) => item.photos);

  const {
    location,
    language,
    availability,
    reply,
    dineindesc,
    eventsphotos = [],
    deliverydesc,
    dealphotos = [],
    eventsdesc,
    hostExperience = [],
    chefs = [],
  } = hostDetails || {};

  const experienceImages = getAllPhotos(hostExperience);
  const hostChefsList = chefList.filter((chef) => chefs.includes(chef._id));

  const allMedia = [...eventsphotos, ...dealphotos, ...experienceImages];

  useEffect(() => {
    const loadMedia = (url) => {
      return new Promise((resolve) => {
        const isVideo = url.endsWith(".mp4") || url.endsWith(".mov") || url.endsWith(".webm");
        const media = isVideo ? document.createElement("video") : new Image();
        media.src = url;

        if (isVideo) {
          media.onloadeddata = resolve;
        } else {
          media.onload = resolve;
        }

        media.onerror = resolve;
      });
    };

    setTotalMedia(allMedia.length);
    Promise.all(allMedia.map(loadMedia)).then(() => {
      setLoadedCount(allMedia.length);
    });
  }, [eventsphotos, dealphotos, experienceImages]);

  const renderMedia = (url, index, className = "hostDineinMedia") => {
    const isVideo = url.endsWith(".mp4") || url.endsWith(".mov") || url.endsWith(".webm");
    return isVideo ? (
      <video key={index} className={`${className} hostDineinMediaVideo`} src={url} controls playsInline />
    ) : (
      <img key={index} className={className} src={url} alt="media" />
    );
  };

  if (loadedCount < totalMedia) {
    return (
      <div className="gallery-loader">
        <Spin size="large" />
      </div>
    );
  }

const aboutText =
  "I manage a talented team of chefs, bringing unique flavors to events and restaurants. From intimate weddings to high-profile collaborations, we bring culinary visions to life with creativity and precision.";

  return (
    <div className="hostDineinWrapperContainer">
      <div className="hostAboutLabelTextWrapper">
        <div className="hostAboutLabelText Satoshi">About the host</div>
        <div className="hostAboutLabelTextDesc Satoshi">
        {showFullAboutText ? aboutText : `${aboutText.slice(0, 120)}... `}
        {!showFullAboutText && (
          <span
            onClick={() => setShowFullAboutText(true)}
            style={{ color: "#007BFF", cursor: "pointer" }}
          >
            Read more
          </span>
        )}
      </div>
      </div>

      <div className="hostDineinWrapper">
        <div className="hostDineinLabel Satoshi">Events</div>
        <div className="hostDineinPhotosWrapper">
          {eventsphotos.map((url, index) => renderMedia(url, index))}
        </div>
      </div>

      <div className="hostDineinWrapper">
        <div className="hostDineinLabel Satoshi">Deals</div>
        <div className="hostDineinPhotosWrapper">
          {dealphotos.map((url, index) => renderMedia(url, index))}
        </div>
      </div>

      <div className="hostChefListWrapper Satoshi">
        <div className="hostChefLabel Satoshi">Chef hosted</div>
        <div className="hostChefCardWrapper">
          {hostChefsList.map((chef) => {
            const chefImage = chef?.profileImg?.includes("amazonaws.com")
              ? chef?.profileImg
              : S3_MENU_THUMBNAIL_FOLDER + chef?.profileImg;

            const allCuisineList = chef?.cuisine.split(",");
            const chefTimeLabel = getStatusLabel(chef, deliveryDetails, isServiceable);

            return (
              <div className="hostChefCardContainer" key={chef._id}>
                <div className="hostChefCardImageWrapper">
                  <img className="hostChefCardImage" src={chefImage} alt="img" />
                  <div className="hostChefName Satoshi">{chef.name}</div>
                  <div className="hostChefTimeWrapper">
                    <ClockIconSvg />
                    <div className="hostChefTimeLabel Satoshi">{chefTimeLabel}</div>
                  </div>
                </div>
                <ul className="hostChefCuisineLabels">
                  {allCuisineList.map((cuisine, i) => (
                    <li key={i} className="hostChefCuisineLabel Satoshi">{cuisine}</li>
                  ))}
                </ul>
                <div className="hostChefExploreMenuWrapper">
                  <button
                    className="hostChefExploreMenu Satoshi transparentBtn"
                    onClick={() => onChefClick(chef._id)}
                  >
                    Explore menu <RightIconSvg />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="experiencesBoxWrapper">
        <div className="experiencesContainer">
          <div className="experiencesLabelTxt Satoshi">Experiences</div>
          <div onClick={onViewAllClick} className="experiencesViewAllBtn Satoshi">
            View all
          </div>
        </div>
        <HostImageGrid experienceImages={experienceImages} />
      </div>
    </div>
  );
};

export default HostDetailsComponent;
